import { useEffect } from "react";
import { getProductosPredeterminados } from "../services/productosService";
import { crearLineaVacia, lineasDesdePredeterminados } from "../utils/lineas";
import { useLineas } from "./useLineas";

// Líneas del Nuevo Pedido: el núcleo compartido (useLineas) más lo propio de
// un pedido nuevo: productos predeterminados de la dirección y limpieza de
// líneas al cambiar de cliente / dirección.
export const useLineasPedido = ({
  uuidPedido,
  clienteSeleccionado,
  direccionSeleccionada,
  tabla,
}) => {
  const lineas = useLineas({ uuidPedido, tabla });
  const { setDatosRenglon } = lineas;

  // El orden de estos dos efectos es el del original: primero se dispara la
  // carga de predeterminados (asíncrona) y después se limpian las líneas.
  // "vigente" descarta la respuesta si mientras tanto cambió la dirección (o se
  // cerró el modal): así una respuesta lenta de la dirección anterior no pisa
  // las líneas de la actual.
  useEffect(() => {
    let vigente = true;

    if (Object.keys(direccionSeleccionada).length !== 0) {
      getProductosPredeterminados(direccionSeleccionada.id)
        .then((data) => {
          if (vigente) setDatosRenglon(lineasDesdePredeterminados(data, uuidPedido));
        })
        .catch((error) => {
          // Sin predeterminados se arranca con una línea vacía (igual que una
          // dirección que no tiene), así el usuario puede cargar a mano.
          console.error("Error cargando productos predeterminados:", error);
          if (vigente) setDatosRenglon([crearLineaVacia(uuidPedido)]);
        });
    }

    return () => {
      vigente = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [direccionSeleccionada]);

  useEffect(() => {
    setDatosRenglon([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clienteSeleccionado, direccionSeleccionada]);

  return lineas;
};
